/**
 * Class description
 *
 * Created: 2019-08-05
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";

export class WinterHoardLogoView extends BaseView {
    private _logo:PIXI.Sprite;
    private _logoSpine:PIXI.spine.Spine;
    private _layer:ScalableLayer;
    private _mode:string;

    private _normalAnimation:string;
    private _idleAnimation:string;

    constructor() {
        super(ResourcesGroupName.MAIN);
        this._layer = StageManager.getLayer(WinterHoardLayerConfig.LOGO.name);
    }

    protected addEventListeners():void {
        //EventHandler.addEventListener(this, GameModeEvent.GAME_MODE_TRANSITION_PREPARE, (event:GameModeEvent) => this.onChangeMode(event));
    }

    private onChangeMode(event:GameModeEvent) {
        this._mode = event.toMode;
        this.update();
    }

    /*protected onResize(resizeData:IResizeData):void {
        this.update();
    }*/

    protected initAnimations():void {
        this._logo = new PIXI.Sprite();
        this._logo.anchor.set(0.5, 0.5);

        this._logoSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("logoSpine"));
        const animation:any = this._logoSpine.skeleton.data.animations;
        this._normalAnimation = animation[1].name;
        this._idleAnimation = animation[0].name;

        this._logoSpine.state.setAnimation(0, this._normalAnimation, true);
        this._logo.addChild(this._logoSpine);
        //console.log(this._logoSpine.skeleton.data.animations);


        this.addChild(this._logo);
        this._layer.addChild(this);

        // Add spine on end to set idle
        this._logoSpine.state.addListener({
            //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
            complete: (entry:PIXI.spine.core.TrackEntry) => {
                if(entry.animation.name === this._idleAnimation) {
                    this._logoSpine.state.setAnimation(0, this._normalAnimation, true);
                }
            }
            //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
            //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
        });
    }

    public playLogoIdle():void {
        //this._logoSpine.state.timeScale = -1;
        this._logoSpine.state.setAnimation(0, this._idleAnimation, false);
    }

    protected onResize(resizeData: IResizeData): void {
        if(resizeData.orientation == Orientation.LANDSCAPE) {
            if(resizeData.width / resizeData.height <1.775){
                this._logo.scale.set(0);
            }else{
                this._logo.scale.set(1, 1);
                this._logo.position.set(-100, 45);
            }

        }
        else {

            if(resizeData.height > 970) {
                this._logo.scale.set(0.6, 0.6);
                this._logo.position.set(360, -180);
            }
            else {
                this._logo.scale.set(0.35, 0.35);
                this._logo.position.set(350, -95);
            }
        }
    }


    private update() {
        if(this._resizeData.orientation == Orientation.LANDSCAPE) {
            this._logo.getChildByName("portrait").visible = false;
            this._logo.getChildByName("landscape").visible = true;
            this._logo.position.set(358, 40);
        }
        else {
            this._logo.getChildByName("landscape").visible = false;
            this._logo.getChildByName("portrait").visible = true;
            this._logo.position.set(360, -200);
        }
    }


    public show() {
        this._layer.addChild(this);
    }

    public hide() {
        this._layer.removeChild(this);
    }


}